<template>
	<section>
		<v-form ref="formActual">
			<v-layout row wrap>
				<v-flex xs12 text-h5 primary--text font-weight-bold>
					1. Cambio de peso
				</v-flex>
				<v-flex xs12 md3>
					Variación en últimos 6 meses
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						v-model="valor.ValoracionUltimos6Meses"
						:rules="[
							!!valor.ValoracionUltimos6Meses ||
								'Campo Obligatorio'
						]"
						hide-details="auto"
						class="campo-formulario"
						suffix="kg"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md6 class="pl-5">
					<v-radio-group
						v-model="valor.ValoracionUltimos6Meses_Clasificacion"
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
					>
						<v-radio label="A" value="A"></v-radio>
						<v-radio label="B" value="B"></v-radio>
						<v-radio label="C" value="C"></v-radio>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 md3>
					Variación porcentual
				</v-flex>
				<v-flex xs12 md3>
					<v-autocomplete
						:items="catalogos.VariacionPorcentual"
						return-object
						item-text="Descripcion"
						v-model="valor.ValoracionPorcentual"
						:rules="[
							!!valor.ValoracionPorcentual || 'Campo Obligatorio'
						]"
						hide-details="auto"
						class="campo-formulario"
					></v-autocomplete>
				</v-flex>
				<v-flex xs12 md6 class="pl-5">
					<v-radio-group
						v-model="valor.VariacionPorcentual_Clasificacion"
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
					>
						<v-radio label="A" value="A"></v-radio>
						<v-radio label="B" value="B"></v-radio>
						<v-radio label="C" value="C"></v-radio>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 md3>
					Variación en las últimas 2 semanas
				</v-flex>
				<v-flex xs12 md3>
					<v-autocomplete
						:items="catalogos.VariacionUltimas2Semanas"
						return-object
						item-text="Descripcion"
						v-model="valor.VariacionUltimas2Semanas"
						:rules="[
							!!valor.VariacionUltimas2Semanas ||
								'Campo Obligatorio'
						]"
						hide-details="auto"
						class="campo-formulario"
					></v-autocomplete>
				</v-flex>
				<v-flex xs12 md6 class="pl-5">
					<v-radio-group
						v-model="valor.VariacionUltimas2Semanas_Clasificacion"
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
					>
						<v-radio label="A" value="A"></v-radio>
						<v-radio label="B" value="B"></v-radio>
						<v-radio label="C" value="C"></v-radio>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 text-h5 primary--text font-weight-bold>
					2. Alimentación
				</v-flex>
				<v-flex xs12 md3>
					Variaciones en la ingesta
				</v-flex>
				<v-flex xs12 md3>
					<v-radio-group
						v-model="valor.VariacionesEnIngesta"
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
					>
						<v-radio label="SI" :value="true"></v-radio>
						<v-radio label="NO" :value="false"></v-radio>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 md6 class="pl-5">
					<v-radio-group
						v-model="valor.VariacionesEnIngesta_Clasificacion"
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
					>
						<v-radio label="A" value="A"></v-radio>
						<v-radio label="B" value="B"></v-radio>
						<v-radio label="C" value="C"></v-radio>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 md3>
					Duración
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						v-model="valor.Duracion"
						:rules="[!!valor.Duracion || 'Campo Obligatorio']"
						hide-details="auto"
						class="campo-formulario"
						suffix="semanas"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md6 class="pl-5">
					<v-radio-group
						v-model="valor.Duracion_Clasificacion"
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
					>
						<v-radio label="A" value="A"></v-radio>
						<v-radio label="B" value="B"></v-radio>
						<v-radio label="C" value="C"></v-radio>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 md3>
					Tipo
				</v-flex>
				<v-flex xs12 md3>
					<v-autocomplete
						:items="catalogos.TiposDieta"
						return-object
						item-text="Descripcion"
						v-model="valor.TipoDieta"
						:rules="[!!valor.TipoDieta || 'Campo Obligatorio']"
						hide-details="auto"
						class="campo-formulario"
					></v-autocomplete>
				</v-flex>
				<v-flex xs12 md6 class="pl-5">
					<v-radio-group
						v-model="valor.TipoDieta_Clasificacion"
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
					>
						<v-radio label="A" value="A"></v-radio>
						<v-radio label="B" value="B"></v-radio>
						<v-radio label="C" value="C"></v-radio>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 text-h5 primary--text font-weight-bold>
					3. Sintomas gastrointestinales
				</v-flex>
				<v-flex xs12 md6>
					<v-radio-group
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
					>
						<v-checkbox
							v-model="valor.SintomasGastrointestinales"
							class="campo-formulario mr-4 mt-2 mb-2"
							hide-details="auto"
							label="Nauseas"
							value="Nauseas"
						></v-checkbox>
						<v-checkbox
							v-model="valor.SintomasGastrointestinales"
							class="campo-formulario mr-4 mt-2 mb-2"
							hide-details="auto"
							label="Vómito"
							value="Vómito"
						></v-checkbox>
						<v-checkbox
							v-model="valor.SintomasGastrointestinales"
							class="campo-formulario mr-4 mt-2 mb-2"
							hide-details="auto"
							label="Diarrea"
							value="Diarrea"
						></v-checkbox>
						<v-checkbox
							v-model="valor.SintomasGastrointestinales"
							class="campo-formulario mr-4 mt-2 mb-2"
							hide-details="auto"
							label="Anorexia"
							value="Anorexia"
						></v-checkbox>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 md6 class="pl-5">
					<v-radio-group
						v-model="valor.SintomasGastrointestinales_Clasificacion"
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
					>
						<v-radio label="A" value="A"></v-radio>
						<v-radio label="B" value="B"></v-radio>
						<v-radio label="C" value="C"></v-radio>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 text-h5 primary--text font-weight-bold>
					4. Deterioro funcional debido a desnutrición
				</v-flex>
				<v-flex xs12 md3>
					Deterioro global
				</v-flex>
				<v-flex xs12 md3>
					<v-autocomplete
						:items="catalogos.Deterioros"
						return-object
						item-text="Descripcion"
						v-model="valor.DeterioroGlobal"
						:rules="[
							!!valor.DeterioroGlobal || 'Campo Obligatorio'
						]"
						hide-details="auto"
						class="campo-formulario"
					></v-autocomplete>
				</v-flex>
				<v-flex xs12 md6 class="pl-5">
					<v-radio-group
						v-model="valor.DeterioroGlobal_Clasificacion"
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
					>
						<v-radio label="A" value="A"></v-radio>
						<v-radio label="B" value="B"></v-radio>
						<v-radio label="C" value="C"></v-radio>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 md3>
					Variación en últimas 2 semanas
				</v-flex>
				<v-flex xs12 md3>
					<v-autocomplete
						:items="catalogos.VariacionDesnutricion"
						v-model="valor.VariacionDesnutricion"
						:rules="[
							!!valor.VariacionDesnutricion || 'Campo Obligatorio'
						]"
						return-object
						item-text="Descripcion"
						hide-details="auto"
						class="campo-formulario"
					></v-autocomplete>
				</v-flex>
				<v-flex xs12 md6 class="pl-5">
					<v-radio-group
						v-model="valor.VariacionDesnutricion_Clasificacion"
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
					>
						<v-radio label="A" value="A"></v-radio>
						<v-radio label="B" value="B"></v-radio>
						<v-radio label="C" value="C"></v-radio>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 text-h5 primary--text font-weight-bold>
					5. Evidencia de
				</v-flex>
				<v-flex xs12 text-h4 primary--text>
					1) Pérdida de grasa subcutánea
				</v-flex>
				<v-flex xs12 md6>
					<v-radio-group
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
					>
						<v-checkbox
							v-model="valor.PerdidaGrasaSubcutanea"
							class="campo-formulario mr-4 mt-2 mb-2"
							hide-details="auto"
							label="Debajo del ojo"
							value="Debajo del ojo"
						></v-checkbox>
						<v-checkbox
							v-model="valor.PerdidaGrasaSubcutanea"
							class="campo-formulario mr-4 mt-2 mb-2"
							hide-details="auto"
							label="Biceps"
							value="Biceps"
						></v-checkbox>
						<v-checkbox
							v-model="valor.PerdidaGrasaSubcutanea"
							class="campo-formulario mr-4 mt-2 mb-2"
							hide-details="auto"
							label="Triceps"
							value="Triceps"
						></v-checkbox>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 md6 class="pl-5">
					<v-radio-group
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
						v-model="valor.PerdidaGrasaSubcutanea_Clasificacion"
					>
						<v-radio label="Normal" value="Normal"></v-radio>
						<v-radio label="Leve" value="Leve"></v-radio>
						<v-radio label="Moderada" value="Moderada"></v-radio>
						<v-radio label="Grave" value="Grave"></v-radio>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 text-h4 primary--text>
					2) Pérdida de masa muscular
				</v-flex>
				<v-flex xs12 md6>
					<v-layout row>
						<v-flex xs2>
							<v-checkbox
								v-model="valor.PerdidaMasaMuscular"
								class="campo-formulario"
								hide-details="auto"
								label="Sienes"
								value="Sienes"
							></v-checkbox>
						</v-flex>
						<v-flex xs2>
							<v-checkbox
								v-model="valor.PerdidaMasaMuscular"
								class="campo-formulario"
								hide-details="auto"
								label="Clavícula"
								value="Clavícula"
							></v-checkbox>
						</v-flex>
						<v-flex xs2>
							<v-checkbox
								v-model="valor.PerdidaMasaMuscular"
								class="campo-formulario"
								hide-details="auto"
								label="Omóplato"
								value="Omóplato"
							></v-checkbox>
						</v-flex>
						<v-flex xs2>
							<v-checkbox
								v-model="valor.PerdidaMasaMuscular"
								class="campo-formulario"
								hide-details="auto"
								label="Espalda alta"
								value="Espalda alta"
							></v-checkbox>
						</v-flex>
						<v-flex xs2>
							<v-checkbox
								v-model="valor.PerdidaMasaMuscular"
								class="campo-formulario"
								hide-details="auto"
								label="Costillas"
								value="Costillas"
							></v-checkbox>
						</v-flex>
						<v-flex xs2>
							<v-checkbox
								v-model="valor.PerdidaMasaMuscular"
								class="campo-formulario"
								hide-details="auto"
								label="Hombros"
								value="Hombros"
							></v-checkbox>
						</v-flex>
						<v-flex xs2>
							<v-checkbox
								v-model="valor.PerdidaMasaMuscular"
								class="campo-formulario"
								hide-details="auto"
								label="Cuádriceps"
								value="Cuádriceps"
							></v-checkbox>
						</v-flex>
						<v-flex xs2>
							<v-checkbox
								v-model="valor.PerdidaMasaMuscular"
								class="campo-formulario"
								hide-details="auto"
								label="Pantorrilla"
								value="Pantorrilla"
							></v-checkbox>
						</v-flex>
						<v-flex xs2>
							<v-checkbox
								v-model="valor.PerdidaMasaMuscular"
								class="campo-formulario"
								hide-details="auto"
								label="Dorso de mano"
								value="Dorso de mano"
							></v-checkbox>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12 md6 class="pl-5">
					<v-radio-group
						v-model="valor.PerdidaMasaMuscular_Clasificacion"
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
					>
						<v-radio label="Normal" value="Normal"></v-radio>
						<v-radio label="Leve" value="Leve"></v-radio>
						<v-radio label="Moderada" value="Moderada"></v-radio>
						<v-radio label="Grave" value="Grave"></v-radio>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 text-h4 primary--text>
					3) Edema
				</v-flex>
				<v-flex xs12 md6>
					<v-radio-group
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
					>
						<v-checkbox
							v-model="valor.Edema"
							class="campo-formulario mr-4 mt-2 mb-2"
							hide-details="auto"
							label="Sacro"
							value="Sacro"
						></v-checkbox>
						<v-checkbox
							v-model="valor.Edema"
							class="campo-formulario mr-4 mt-2 mb-2"
							hide-details="auto"
							label="Tobillo"
							value="Tobillo"
						></v-checkbox>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 md6 class="pl-5">
					<v-radio-group
						v-model="valor.Edema_Clasificacion"
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
					>
						<v-radio label="Normal" value="Normal"></v-radio>
						<v-radio label="Leve" value="Leve"></v-radio>
						<v-radio label="Moderada" value="Moderada"></v-radio>
						<v-radio label="Grave" value="Grave"></v-radio>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 text-h5 primary--text font-weight-bold>
					Clasificación global
				</v-flex>
				<v-flex xs12 class="justify-center">
					<v-radio-group
						hide-details="auto"
						class="control-formulario"
						row
						mandatory
						v-model="valor.ClasificacionGlobal"
					>
						<v-radio
							label="A. Bien nutrido"
							value="Bien nutrido"
						></v-radio>
						<v-radio
							label="B. Desnutrición leve/moderada"
							value="Desnutricion leve/moderada"
						></v-radio>
						<v-radio
							label="C. Desnutrición grave"
							value="Desnutricion grave"
						></v-radio>
					</v-radio-group>
				</v-flex>
			</v-layout>
		</v-form>
		<v-layout row class="mt-3" v-if="!esVisita">
			<v-flex xs6>
				<v-btn color="primary" @click.prevent="anterior">
					<v-icon>arrow_back_ios</v-icon> ANTERIOR
				</v-btn>
			</v-flex>
			<v-flex xs6 class="text-right">
				<v-btn color="primary" @click.prevent="guardar">
					<v-icon>arrow_forward_ios</v-icon> SIGUIENTE
				</v-btn>
			</v-flex>
		</v-layout>
	</section>
</template>

<script>
import ServicioHistorialClinico from "../../../services/historialClinico";
export default {
	props: ["datos", "esVisita", "validateForm"],
	name: "valoracionGlobalSubjetiva",
	computed: {
		historiaCliniciaId() {
			return this.$route.params.historiaClinicaId;
		}
	},
	methods: {
		siguiente() {
			this.$emit("siguiente");
		},
		anterior() {
			this.$emit("anterior");
		},
		async guardar() {
			if (this.$refs.formActual.validate()) {
				const res = await ServicioHistorialClinico.guardarValoracionGlobal(
					this.historiaCliniciaId,
					this.valor
				);
				if (res.data.result === 1) {
					this.siguiente();
				} else {
					this.$root.mensajeError = res.data.message;
				}
			} else {
				this.$root.mensajeError =
					"Por favor llene los campos requeridos.";
			}
		},
		obtenerCatalogos() {
			this.catalogos.VariacionPorcentual = this.$root.generarCatalogo([
				"aumento-pérdida < 5 %",
				"pérdida 5-10 %",
				"pérdida > 10%"
			]);
			this.catalogos.VariacionUltimas2Semanas = this.$root.generarCatalogo(
				["aumento", "ninguna", "pérdida"]
			);
			this.catalogos.TiposDieta = this.$root.generarCatalogo([
				"dieta sólida subóptima",
				"dieta completa líquida",
				"líquidos hipocalóricos",
				"hambre"
			]);
			this.catalogos.Deterioros = this.$root.generarCatalogo([
				"ninguno",
				"moderado",
				"grave"
			]);
			this.catalogos.VariacionDesnutricion = this.$root.generarCatalogo([
				"mejora",
				"ninguna",
				"empeoramiento"
			]);
		}
	},
	data() {
		return {
			catalogos: {
				VariacionPorcentual: [],
				VariacionUltimas2Semanas: [],
				TiposDieta: [],
				Deterioros: [],
				VariacionDesnutricion: []
			},
			valor: {
				Edema: [],
				PerdidaGrasaSubcutanea: [],
				PerdidaMasaMuscular: [],
				SintomasGastrointestinales: []
			}
		};
	},
	mounted() {
		this.obtenerCatalogos();
	},
	watch: {
		datos() {
			if (this.datos) {
				this.valor =
					typeof this.datos === "string"
						? JSON.parse(this.datos)
						: this.datos;
			}
		},
		validateForm() {
			if (this.validateForm) {
				if (!this.$refs.formActual.validate()) {
					this.$emit("valorCambiado", null);
				} else {
					this.$emit("valorCambiado", this.valor);
				}
			}
		}
	}
};
</script>
